'use client';

import { PropsWithChildren } from 'react';
import { Disclosure, DisclosureButton, DisclosurePanel, Transition } from '@headlessui/react';
import classNames from 'classnames';
import SafeHtml from '@/components/safe-html';
import { IconArrowSquareDown } from '@/components/svg-symbols/icons';
import usePDPData from '../../_utils/use-pdp-data';
type Props = PropsWithChildren & {
  isOpen?: boolean;
};
function HowToUse({
  isOpen = false
}: Props) {
  const {
    data
  } = usePDPData();
  if (!data?.howToUseHtml) return null;
  return <div className='mt-4 flex w-full flex-col rounded border border-border-gray-light bg-surface-solid-0 px-2 py-3 lg:mt-6' data-sentry-component="HowToUse" data-sentry-source-file="how-to-use.tsx">
            <Disclosure defaultOpen={isOpen} data-sentry-element="Disclosure" data-sentry-source-file="how-to-use.tsx">
                {({
        open
      }) => <>
                        <DisclosureButton className='flex w-full items-center justify-between'>
                            <span className='text-body-14 font-bold text-text-black lg:text-body-16'>نحوه مصرف</span>

                            <IconArrowSquareDown className={classNames('expand-more-icon h-6 w-6 transition-all duration-500', {
            'rotate-180': open
          })} />
                        </DisclosureButton>
                        <Transition as='div' className='overflow-hidden transition-all duration-500' enterFrom='transform max-h-0' enterTo='transform max-h-96' leaveFrom='transform max-h-96' leaveTo='transform max-h-0'>
                            <DisclosurePanel className='mt-3 text-caption-12 font-normal text-text-darkGray lg:text-body-14'>
                                <SafeHtml content={data?.howToUseHtml || ''} />
                            </DisclosurePanel>
                        </Transition>
                    </>}
            </Disclosure>
        </div>;
}
export default HowToUse;